<template>
  <modals-request
    ref="modal"
    v-model="payload"
    :request-class="proxyRequest"
    title="Adicionar fornecedor ao produto"
    :card-width="800"
    :disabled-send="disabled"
    persistent
    manual-close
    :config-swal="swalConfig"
    @success="success($event)"
  >
    <template v-slot:open="{on}">
      <v-btn
        id="open"
        icon
        color="#2ABD49"
        width="40"
        height="40"
        outlined
        :disabled="!bool(getProductId)"
        v-on="on"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <form-group>
      <v-row class="mb-3">
        <v-col cols="4">
          <span>Vincular fornecedor</span>
        </v-col>
        <v-col cols="8">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <input-select
          id="input:idFornecedor"
          v-model="payload.idFornecedor"
          label="Fornecedores"
          :items="fornecedorOptions"
          :loading="loading"
          clearable
        />
      </v-row>
      <v-row class="mb-6">
        <v-col cols="4">
          <span>Criar novo fornecedor</span>
        </v-col>
        <v-col cols="8">
          <v-divider />
        </v-col>
      </v-row>
      <fornecedor-content
        v-model="payload.create"
        class="ma-0 pa-0"
        title=""
      />
      <v-row
        v-if="isWrong"
        class="pa-3"
      >
        <span>Só é possivel criar um fornecedor ou vincular um existente!</span>
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import FornecedorRequest from 'Modules/contacard/produto/fornecedor/FornecedorRequest';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import ProdutoRequest from '../../../product/ProdutoRequest';
import FornecedorContent from '../../../fornecedor/FornecedorContent.vue';

export default {
  name: 'CreateFornecedorTemplate',
  components: { ModalsRequest, FormGroup, FornecedorContent },
  mixins: [RequestSelectMixin, ServiceMixin],
  data: () => ({
    requestClass: FornecedorRequest,
    requestProduto: ProdutoRequest,
    loading: false,
    payload: {
      create: {
        nomFornecedor: '',
        numCnpj: '',
      },
      idFornecedor: '',
    },
    fornecedorOptions: [],
    fornecedores: [],
    swalConfig: {
      successMessage: 'Sucesso ao vincular fornecedor !',
      errorMessage: 'Falha ao vincular fornecedor',
    },
  }),
  computed: {
    isCreate() {
      return this.bool(this.payload.create.nomFornecedor)
      && this.bool(this.payload.create.numCnpj);
    },
    isLinked() {
      return this.bool(this.payload.idFornecedor);
    },
    isWrong() {
      return this.isCreate && this.isLinked;
    },
    disabled() {
      return this.isWrong || (!this.isLinked && !this.isCreate);
    },
    getProductId() {
      return this.template.idProduto;
    },
    proxyRequest() {
      return (payload) => {
        if (this.isCreate) {
          return this.requestClass.save(payload.create);
        }
        return this.requestProduto.addFornecedor(
          this.payload.idFornecedor,
          this.getProductId,
        );
      };
    },
    allReadyFornecedores() {
      return this.template.fornecedorOptions;
    },
  },
  watch: {
    allReadyFornecedores: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value) {
          this.fornecedorOptions = [
            ...this.fornecedores,
          ];
        }
        this.$nextTick(() => {
          this.handleAllReadyFornecedores();
        });
      },
    },
    fornecedores: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value) {
          this.fornecedorOptions = [
            ...this.fornecedores,
          ];
        }
      },
    },
  },
  created() {
    this.listFornecedores();
  },
  methods: {
    listFornecedores() {
      this.loading = true;
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions('fornecedores', 'nomFornecedor'),
        'Falha ao buscar fornecedores',
        this.fornecedorCallBack,
      );
    },
    fornecedorCallBack() {
      this.loading = false;
    },
    handleAllReadyFornecedores() {
      this.allReadyFornecedores.forEach(
        (fornecedor) => this.removeFornecedorInList(
          fornecedor.item.fornecedor.id,
        ),
      );
    },
    removeFornecedorInList(fornecedorId) {
      const fornecedorPos = this.getPosition(fornecedorId);

      if (fornecedorPos >= 0) {
        this.fornecedorOptions.splice(
          fornecedorPos,
          1,
        );
      }
    },
    getPosition(id) {
      return this.fornecedorOptions.findIndex(
        (fornecedor) => fornecedor.value === id,
      );
    },
    bool(value) {
      return new Boolean(value).valueOf();
    },
    success(res) {
      if (this.isCreate) {
        if (res && res.data) {
          this.callService(
            this.requestProduto.addFornecedor(
              res.data,
              this.getProductId,
            ).then((response) => response.data),
            this.successCb,
            this.swalConfig,
          );
        }
      } else {
        this.successCb(res);
      }
    },
    successCb(res) {
      this.$refs.modal.loading = false;
      if (res) {
        this.$refs.modal.dialog = false;
        this.$emit('success', res);
      }
    },
  },
  inject: {
    template: {
      default() {
        return {
          idProduto: '',
          fornecedorOptions: [],
        };
      },
    },
  },
};
</script>

<style>

</style>
